<template>
  <div>
    <right-panel class="float-right" id="sidebar-new-accessor" width="600px" :icon="'mdi mdi-plus'" :text="$t('accessing-persons.new')" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <FormAccessor @onFormSave="onAccessorSelect" :hide-library="true" />
      </div>
    </right-panel>

    <h6>{{ $t("accessing-persons.name") }}</h6>
    <filter-select
      id="accessorFilter"
      ref="accessorFilter"
      :placeholder="$t('accessing-persons.name')"
      :multiple="false"
      @filter="accessorSearch"
      :selected="form.libraryItem"
      @changed="onAccessorSelect"
    />
    <div>
      <right-panel class="float-right" id="sidebar-new-access-restriction" width="600px" :icon="'mdi mdi-plus'" :text="$t('access-restriction.new')" @hidden="rightPanelClosed">
        <div class="pl-5 pr-5">
          <FormRestriction @onFormSave="onRestrictionSelect" :hide-library="true" />
        </div>
      </right-panel>
      <h6 class="mt-3">{{ $t("access-restriction.permission") }}</h6>
    </div>

    <filter-select
      id="storageFilter"
      ref="storageFilter"
      :placeholder="$t('access-restriction.permission')"
      :multiple="false"
      @filter="restrictionSearch"
      :selected="form.restriction"
      @changed="onRestrictionSelect"
    />

    <sweet-button @click="save()" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button>

    <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
      {{ $t("common.cancel") }}
    </sweet-button>
  </div>
</template>

<script>
import FormRestriction from "@modules/access-restriction/workspace-library-access-restriction-form";
import FormAccessor from "@modules/accessor/workspace-library-accessor-form";
import { required } from "vuelidate/lib/validators";

export default {
  props: ["prepareMode", "id"],

  components: { FormAccessor, FormRestriction },
  validations: {
    form: {
      libraryItem: {
        required,
      },

      restriction: {
        required,
      },
    },
  },
  data() {
    return {
      form: { libraryItem: undefined, restriction: undefined },
    };
  },

  computed: {
    isUpdating() {
      return this.$store.getters["dataAccessAndRestriction/isUpdating"];
    },
    editedData() {
      return this.$store.getters["dataAccessAndRestriction/editedData"];
    },
    editedAccessAndRestriction() {
      return this.$store.getters["dataAccessAndRestriction/editedAccessAndRestriction"];
    },
  },
  watch: {
    editedAccessAndRestriction: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.form = { ...v };
        }
      },
    },
  },
  mounted() {},
  methods: {
    cancel() {
      this.form = { libraryItem: undefined, restriction: undefined };
      this.$store.dispatch("dataAccessAndRestriction/resetForm");
      this.$root.$emit("bv::toggle::collapse", this.id);
    },
    async save() {
      if (!this.prepareMode) {
        const ok = await this.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
      }

      try {
        this.form.data = this.editedData;

        if (this.form._id && this.form.libraryItem != this.editedAccessAndRestriction?.libraryItem) {
          this.$store.commit("gdprInventoryBulkUpdate/removeAccessAndRestriction", this.editedAccessAndRestriction);
        }

        if (this.prepareMode) {
          this.$emit("onSaved", { ...this.form });
        } else {
          await this.$store.dispatch("dataAccessAndRestriction/save", { ...this.form });
          this.$toast.success(this.$t("common.success"));
        }

        this.form = { libraryItem: undefined, restriction: undefined };
        this.$root.$emit("bv::toggle::collapse", this.id);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async accessorSearch(value, callback) {
      const response = await this.$store.dispatch(`accessor/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onAccessorSelect(item) {
      this.form = { ...this.form, libraryItem: item };
    },

    async restrictionSearch(value, callback) {
      const response = await this.$store.dispatch(`accessRestriction/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onRestrictionSelect(item) {
      this.form = { ...this.form, restriction: item };
    },
    rightPanelClosed() {},
  },
};
</script>
